module.exports = __webpack_public_path__ + "img/symbol_5.d734dbe0.png";